import { SxProps } from '@material-ui/system'
import React from 'react'
import { Controller, Control, FieldName } from 'react-hook-form'
import { PasswordInput, PasswordInputProps } from '../PasswordInput'

export type HfPasswordInputProps<TFormValues> = PasswordInputProps & {
  name: FieldName<TFormValues>,
  control: Control<TFormValues>,
  endAdornment?: React.ReactNode,
  startAdornment?: React.ReactNode,
  error?: string | boolean,
  label?: string,
  sx?: SxProps,
  placeholder?: string,
  containerClassName?: string,
  useNewFont?: boolean,
  errorMessage?: string
}

export function HfPasswordInput<TFormValues> (props: React.PropsWithChildren<HfPasswordInputProps<TFormValues>>) {
  const { control, name, error, sx, ...rest } = props

  return (
    <Controller
      control={control as any}
      name={name}
      render={({ field }) => (
        <PasswordInput
          {...rest}
          {...field}
          sx={sx}
          error={Boolean(error)}
          onChange={(ev) => field.onChange(ev.target.value)}
        />
      )}
    />
  )
}
